<template>
    <div class="mobile-container">
        <!-- 头部导航 -->
        <div class="header">
            <div class="header-title">{{ title }}</div>
        </div>

        <!-- 表单内容 -->
        <div class="form-content">
            <div class="mobile-form">
                <div class="level">
                    <span class="dot"></span>
                    <span class="text"> 公司信息</span>
                </div>

                <div style="padding: 0 8px;">
                    <div class="form-item">
                        <label class="form-label">单位全称：</label>
                        <div class="form-input ">{{ info.companyName }}</div>
                    </div>

                    <div class="form-item">
                        <label class="form-label">备案日期：</label>
                        <div class="form-input">{{ info.recordDate }}</div>
                    </div>

                    <div class="form-item">
                        <label class="form-label">单位地址：</label>
                        <div class="form-input">{{ info.address }}</div>
                    </div>

                    <div class="form-item">
                        <label class="form-label">外事主管部门：</label>
                        <div class="form-input">{{ info.deptName }}</div>
                    </div>

                    <div class="form-item">
                        <label class="form-label">因公出国(境)请示公章：</label>
                        <div class="form-input" style="border: none" v-if="info.unitOfficialSeal">
                            <el-image :src="info.unitOfficialSeal" alt="" style="width: 80px;height: 80px;" />
                        </div>
                    </div>

                    <div class="form-item">
                        <label class="form-label">因公出国(境)人员备案表公章：</label>

                        <div class="form-input" style="border: none" v-if="info.recordOfficialSeal">
                            <el-image :src="info.recordOfficialSeal" alt="" style="width: 80px;height: 80px;" />
                        </div>
                    </div>

                    <div class="form-item">
                        <label class="form-label">签署样式：</label>

                        <div class="form-input" style="border: none" v-if="info.signature">
                            <el-image :src="info.signature" alt="" style="width: 80px;height: 80px;" />
                        </div>
                    </div>
                </div>

                <div class="level">
                    <span class="dot"></span>
                    <span class="text"> 签发人信息</span>
                </div>

                <div>
                    <el-table :data="listThree" border v-if="listThree.length">
                        <el-table-column prop="userName" label="姓名" width="100"> </el-table-column>
                        <el-table-column prop="duty" label="职务" width="100"> </el-table-column>
                        <el-table-column prop="tel" label="座机"> </el-table-column>
                        <el-table-column prop="phone" label="手机"> </el-table-column>
                        <el-table-column prop="email" label="邮箱"> </el-table-column>
                        <el-table-column prop="remark" label="备注"> </el-table-column>
                    </el-table>
                </div>
                <div class="level">
                    <span class="dot"></span>
                    <span class="text">部门负责人信息</span>
                </div>
                <div>
                    <el-table :data="listOne" border v-if="listOne.length">
                        <el-table-column prop="userName" label="姓名" width="100"> </el-table-column>
                        <el-table-column prop="duty" label="职务" width="100"> </el-table-column>
                        <el-table-column prop="tel" label="座机"> </el-table-column>
                        <el-table-column prop="phone" label="手机"> </el-table-column>
                        <el-table-column prop="email" label="邮箱"> </el-table-column>
                        <el-table-column prop="remark" label="备注"> </el-table-column>
                    </el-table>
                </div>

                <div class="level">
                    <span class="dot"></span>
                    <span class="text">专办员信息</span>
                </div>
                <div>
                    <el-table :data="listTwo" border v-if="listTwo.length">
                        <el-table-column prop="userName" label="姓名" width="100"> </el-table-column>
                        <el-table-column prop="duty" label="职务" width="100"> </el-table-column>
                        <el-table-column prop="tel" label="座机"> </el-table-column>
                        <el-table-column prop="phone" label="手机"> </el-table-column>
                        <el-table-column prop="email" label="邮箱"> </el-table-column>
                        <el-table-column prop="remark" label="备注"> </el-table-column>
                    </el-table>
                </div>

                <div class="level">
                    <span class="dot"></span>
                    <span class="text">附件信息</span>
                </div>
                <div class="form-input" style="border: none">
                    <span class="file-name" style="padding-left: 16px;margin-right: 16px;" v-if="file">{{ file }}</span>
                    <span class="file-name" v-else>无</span>

                    <span class="preview-btn" @click="handlePreviewFile(filePath, file)" v-if="file">预览</span>
                </div>
            </div>
        </div>

        <!-- 底部按钮 -->
        <div class="footer-buttons">
            <el-button class="btn-disagree" @click="confirmManage('N')" size="mini" type="danger">不同意</el-button>
            <el-button class="btn-agree" @click="confirmManage('Y')" size="mini" type="primary">同意</el-button>
        </div>

        <!-- 弹窗组件 -->
        <MessageBox ref="messageBox" @approve="handleApprove" @reject="handleReject" />
    </div>
</template>

<script>
import MobileApi from "@/api/mobile"
import { mapGetters } from "vuex"
import MessageBox from "./messageBox.vue"
export default {
    name: "mobile",
    components: {
        MessageBox
    },
    data() {
        return {
            Api: new MobileApi(),
            info: {
                companyId: "",
                companyName: "",
                recordDate: "",
                address: "",
                deptName: "",
                recordOfficialSeal: "",
                unitOfficialSeal: "",
                signature: "",
                remarks: "",
                status: "",
                recordId: ""
            },
            listOne: [],
            listTwo: [],
            listThree: [],
            file: "",
            filePath: ""
        }
    },
    props: {
        type: {
            type: String,
            default: ""
        },
        missiveId: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        }
    },
    computed: {
        ...mapGetters(["token", "userInfo"])
    },

    mounted() {
        this.getInfo()
    },
    methods: {
        handlePreviewFile(filePath, fileName) {
            let src = `/share-foreign/commannex/viewAnnex?path=${filePath}&token=${this.token}`
            if (fileName.match(/\.pdf$/) || fileName.match(/\.PDF$/)) {
                window.open(src)
            } else {
                this.$message("仅支持pdf类型文件的预览")
            }
        },
        getInfo() {
            this.Api.detail({
                companyId: this.missiveId.split("_")[0]
            }).then(res => {
                for (let i in this.info) {
                    this.info[i] = res.data.entRecord[i]
                }
                const { unitOfficialSeal, recordOfficialSeal, signature } = res.data.entRecord
                if (unitOfficialSeal) {
                    this.info.unitOfficialSeal = `/share-foreign/commannex/viewAnnex?path=${unitOfficialSeal}&token=${this.token}`
                }
                if (recordOfficialSeal) {
                    this.info.recordOfficialSeal = `/share-foreign/commannex/viewAnnex?path=${recordOfficialSeal}&token=${this.token}`
                }
                if (signature) {
                    this.info.signature = `/share-foreign/commannex/viewAnnex?path=${signature}&token=${this.token}`
                }

                this.listOne = res.data.users.filter(a => a.type == 1) || []
                this.listTwo = res.data.users.filter(a => a.type == 2) || []
                this.listThree = res.data.users.filter(a => a.type == 3) || []
                this.file = res.data.entRecord.recordLetter
                this.filePath = res.data.entRecord.recordLetterPath
            })
        },
        //预览pdf
        lookPdf() {
            if (this.missiveId) {
                window.open("/share-foreign/missive/missiveManage/printMissive?" + "missiveId=" + this.missiveId + "&token=" + this.token)
            }
        },
        confirmManage(status) {
            if (status === "Y") {
                // 显示确认弹窗
                this.$refs.messageBox.showConfirm({
                    title: "提示",
                    message: "是否确认同意审批？"
                })
            } else {
                // 显示输入弹窗
                this.$refs.messageBox.showInput({
                    title: "请输入审批意见",
                    placeholder: ""
                })
            }
        },

        // 处理同意操作
        handleApprove() {
            let obj = {
                recordId: this.missiveId.split("_")[1],
                opinion: "",
                agree: "Y"
            }
            this.submit(obj)
            // 这里可以调用API提交审批结果
        },

        // 处理不同意操作
        handleReject(reason) {
            let obj = {
                recordId: this.missiveId.split("_")[1],
                opinion: reason,
                agree: "N"
            }
            this.submit(obj)
        },
        submit(obj) {
            this.Api.submitTaskCompany(obj)
                .then(res => {
                    console.log(res)
                    console.log("操作成功了")

                    this.$emit("submit")
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.mobile-container {
    min-height: 100vh;

    display: flex;
    flex-direction: column;
    height: 100vh; // 设置固定高度
    overflow: hidden; // 防止整体滚动
}

.header {
    background: linear-gradient(0deg, #8bc8f0, #b1dcfc);
    height: 36px;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 100;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding-left: 32px;
    flex-shrink: 0; // 防止头部被压缩

    .header-title {
        color: #000;
        font-size: 18px;
        font-weight: 500;
    }
}
.level {
    height: 36px;
    background: linear-gradient(0deg, #8bc8f0, #b1dcfc);
    padding-left: 24px;
    display: flex;
    align-items: center;
    margin: 2px 0;
    .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #000;
        margin-right: 6px;
    }
}

.form-content {
    flex: 1;
    padding-bottom: 80px;
    overflow-y: auto; // 允许垂直滚动
    overflow-x: hidden; // 隐藏水平滚动
    -webkit-overflow-scrolling: touch; // iOS 平滑滚动
}

.mobile-form {
    border-radius: 8px;
}

.form-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 15px;
    min-height: 40px; // 确保每行有最小高度

    &:last-child {
        margin-bottom: 0;
    }

    .form-label {
        width: 100px; // 固定宽度而不是最小宽度
        font-size: 14px;
        color: #333;
        font-weight: 500;
        line-height: 40px; // 与input高度一致
        margin-right: 4px;
        flex-shrink: 0;
        text-align: right;
    }

    .form-input {
        flex: 1;

        border: 1px solid #e9ecef;
        color: #495057;
        font-size: 14px;
        border-radius: 4px;
        padding: 10px 15px;
        line-height: 1.5;
        min-height: 20px;
        word-wrap: break-word;
        display: flex;
        align-items: center;

        &.content-box {
            min-height: 120px;
            white-space: pre-wrap;
            align-items: flex-start;
            padding-top: 10px;
        }

        .file-name {
            color: #333;
            font-size: 14px;
            margin-right: 10px;
        }

        .preview-btn {
            color: #4a90e2;
            font-size: 14px;
            cursor: pointer;
            text-decoration: none;

            &:hover {
                color: #357abd;
                text-decoration: underline;
            }
        }
    }
}
.preview-btn {
    color: #4a90e2;
    font-size: 14px;
    cursor: pointer;
    text-decoration: none;

    &:hover {
        color: #357abd;
        text-decoration: underline;
    }
}
.footer-buttons {
    position: fixed;
    background-color: #fff;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    padding: 15px;

    display: flex;
    gap: 10px;
    z-index: 999;
    justify-content: center;
    .el-button {
        width: 80px;
        height: 40px;
        font-size: 16px;
        font-weight: 500;
        border-radius: 6px;
        border: none;
    }
}

// // 移动端响应式
@media (max-width: 768px) {
    .form-content {
        padding-bottom: 60px;
    }

    .form-item {
        margin-bottom: 12px;
        min-height: 36px;

        .form-label {
            width: 100px;
            font-size: 13px;
            line-height: 36px;
            margin-right: 4px;
        }

        .form-input {
            font-size: 13px;
            padding: 8px 12px;

            &.content-box {
                min-height: 100px;
                padding-top: 8px;
            }
        }
    }

    .footer-buttons {
        background-color: #fff;
        padding: 12px;
        display: flex;
        display: flex;
        justify-content: center;

        .el-button {
            flex-grow: 0;
            width: 80px;
            height: 36px;
            font-size: 14px;
        }
    }

    .header {
        padding-left: 16px;

        .header-title {
            font-size: 16px;
        }
    }
}
</style>
